import React, { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import EventCard from "./components/eventCard/EventCard"; // Assuming you have this
import { EventModal } from "./components/eventModal/eventModal"; // Assuming you have this

import classes from "./Events.module.css";
import { testUrl } from "../BaseData";

const Events = () => {
    const { t, i18n } = useTranslation();
    const [announcements, setAnnouncements] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState("");
    const [loading, setLoading] = useState(true);
    const [openModal, setOpenModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [hasNext, setHasNext] = useState(false);
    const [hasPrevious, setHasPrevious] = useState(false);

    const fetchAnnouncements = (page = 1) => {
        setLoading(true);
        axios
            .get(testUrl + `/api/announcements/?page=${page}`)
            .then((response) => {
                // Handle paginated response
                const data = response.data;
                if (data.results) {
                    // Paginated response
                    setAnnouncements(data.results);
                    setTotalPages(Math.ceil(data.count / 10));
                    setHasNext(!!data.next);
                    setHasPrevious(!!data.previous);
                    setCurrentPage(page);
                } else {
                    // Non-paginated response (fallback)
                    setAnnouncements(data);
                }
            })
            .catch((error) => console.error("Error fetching data:", error))
            .finally(() => setLoading(false));
    };
    useEffect(() => {
        fetchAnnouncements();
    }, [i18n.language]);


    const onClickOpenModal = (eventName) => {
        setSelectedEvent(eventName);
        setOpenModal(true);
    };

    return (
        <div id="event" className={classes["wrapper"]}>
            <div className={classes["container"]}>
                <h1 className={classes["header"]}>{t(`E'lonlar`) || "E'lonlar"}</h1>
                <div className={classes["grid"]}>
                    {announcements.map((announcement, index) => (
                        <EventCard
                            key={announcement.id}
                            index={index}
                            extraCurricular={announcement}
                            onClickOpenModal={onClickOpenModal}
                        />
                    ))}
                </div>

                {/* Pagination Controls */}
                {totalPages > 1 && (
                    <div className={classes["pagination"]}>
                        <button
                            onClick={() => fetchAnnouncements(currentPage - 1)}
                            disabled={!hasPrevious}
                            className={classes["paginationButton"]}
                        >
                            {t("previous") || "Oldingi"}
                        </button>
                        <span className={classes["pageInfo"]}>
                            {t("page") || "Sahifa"} {currentPage} / {totalPages}
                        </span>
                        <button
                            onClick={() => fetchAnnouncements(currentPage + 1)}
                            disabled={!hasNext}
                            className={classes["paginationButton"]}
                        >
                            {t("next") || "Keyingi"}
                        </button>
                    </div>
                )}

                <EventModal
                    selectedEvent={selectedEvent}
                    openModal={openModal}
                    setOpenModal={setOpenModal}
                />
            </div>
        </div>
    );
};

export default Events;